import React, { useEffect, useState, useRef } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Icon } from "@mui/material";
import SessionSelector from "CinicComponents/SessionSelector";

const MultiPackageSession = ({
  Patient,
  setPkgSession,
  initialData,
  onDelete,
}) => {
  const [Session, setSession] = useState({});
  const [Quantity, setQuantity] = useState("1");
  const [OriginalPrice, setOriginalPrice] = useState(0);
  const [Discount, setDiscount] = useState("0");
  const [FinalPrice, setFinalPrice] = useState("0");
  const [isEditingDiscount, setIsEditingDiscount] = useState(false);
  const isInitialized = useRef(false);

  const getPrice = (details) => {
    if (!details) return 0;
    const group =
      Patient?.getPatient?.nationalityGroup || Patient?.nationalityGroup;
    if (group === "Egyptian") return details.egyptianPrice || 0;
    if (group === "Arab") return details.arabPrice || 0;
    return details.otherPrice || 0;
  };

  useEffect(() => {
    if (initialData?.sessionId && !isInitialized.current) {
      const price =
        initialData.originalPrice || getPrice(initialData.sessionDetails);
      setSession({
        id: initialData.sessionId,
        name: initialData.sessionName || initialData.getSession?.name,
      });
      setOriginalPrice(price);
      setQuantity(initialData.quantity?.toString() || "1");
      setDiscount(initialData.discount?.toString() || "0");
      const calcFinal =
        initialData.finalPrice ||
        price - (price * (initialData.discount || 0)) / 100;
      setFinalPrice(calcFinal.toString());
      isInitialized.current = true;
    }
  }, [initialData]);

  useEffect(() => {
    if (Session?.id && !isInitialized.current) {
      let price = getPrice(Session);
      setOriginalPrice(price);
      const d = parseFloat(Discount) || 0;
      setFinalPrice((price - (price * d) / 100).toString());
    }
  }, [Session, Patient]);

  useEffect(() => {
    if (Session?.id) {
      setPkgSession({
        tempId: initialData.tempId,
        sessionId: Session.id,
        quantity: parseInt(Quantity) || 0,
        finalPrice: parseFloat(FinalPrice) || 0,
        originalPrice: OriginalPrice,
        discount: parseFloat(Discount) || 0,
      });
    }
  }, [Session, Quantity, FinalPrice, OriginalPrice, Discount]);

  const handleDiscountChange = (val) => {
    setDiscount(val);
    if (val === "") return;
    const d = parseFloat(val) || 0;
    const newPrice = OriginalPrice - (OriginalPrice * d) / 100;
    setFinalPrice(newPrice.toFixed(2));
  };

  const handleFinalPriceChange = (val) => {
    setFinalPrice(val);
    if (val === "" || OriginalPrice === 0) return;
    const fp = parseFloat(val) || 0;
    const newDisc = ((OriginalPrice - fp) / OriginalPrice) * 100;
    setDiscount(newDisc.toFixed(2));
  };

  return (
    <MDBox>
      <MDBox
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
        mt={1}
      >
        <MDBox sx={{ flexGrow: 1, minWidth: "200px" }}>
          {initialData?.isCopied ? (
            <MDInput
              label="Session"
              value={Session?.name || ""}
              fullWidth
              disabled
              sx={{ bgcolor: "#f0f2f5" }}
            />
          ) : (
            <SessionSelector
              setSession={setSession}
              Patient={Patient}
              selectedSessionId={Session?.id}
            />
          )}
        </MDBox>

        <MDBox display="flex" alignItems="center" gap={1}>
          {Session?.id && (
            <MDBox sx={{ minWidth: "80px", textAlign: "right" }}>
              <MDTypography variant="caption" color="text" fontWeight="medium">
                {isEditingDiscount
                  ? `EGP ${parseFloat(FinalPrice).toFixed(2)}`
                  : `${parseFloat(Discount).toFixed(0)}% Off`}
              </MDTypography>
            </MDBox>
          )}

          <MDBox sx={{ width: "80px" }}>
            <MDInput
              label="Qty"
              type="number"
              value={Quantity}
              onChange={(e) => setQuantity(e.target.value)}
              fullWidth
            />
          </MDBox>
        </MDBox>

        <MDBox sx={{ width: "130px" }}>
          <MDInput
            label={isEditingDiscount ? "Disc %" : "Price"}
            type="number"
            value={isEditingDiscount ? Discount : FinalPrice}
            onChange={(e) =>
              isEditingDiscount
                ? handleDiscountChange(e.target.value)
                : handleFinalPriceChange(e.target.value)
            }
            fullWidth
          />
        </MDBox>
        <MDBox display="flex" gap={1}>
          <MDButton
            variant="outlined"
            color="info"
            onClick={() => setIsEditingDiscount(!isEditingDiscount)}
            sx={{ height: "44px" }}
          >
            <Icon>{isEditingDiscount ? "payments" : "percent"}</Icon>
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            onClick={onDelete}
            sx={{ height: "44px" }}
          >
            <Icon>delete</Icon>
          </MDButton>
        </MDBox>
      </MDBox>
      {Session?.id && (
        <MDBox display="flex" gap={3} mt={0.5} ml={1}>
          <MDTypography variant="caption">
            Orig: <b>{OriginalPrice}</b>
          </MDTypography>
          <MDTypography variant="caption" fontWeight="bold">
            Subtotal: EGP{" "}
            {(
              (parseFloat(FinalPrice) || 0) * (parseInt(Quantity) || 0)
            ).toFixed(2)}
          </MDTypography>
        </MDBox>
      )}
    </MDBox>
  );
};

export default MultiPackageSession;
